/* eslint-disable no-param-reassign */

import { produce } from "immer"
import type { UpdateBonusParametersFormStateAction } from "./actions-bonus"
import { BonusProductActionsType } from "./actions-product"
import { initialState } from "./selectors"
import type { BonusState } from "./types"

export default function reducer(
  state: BonusState = initialState,
  action: UpdateBonusParametersFormStateAction
) {
  return produce(state, (nextState: BonusState) => {
    switch (action.type) {
      case BonusProductActionsType.BONUS_PARAMETERS_FORM_UPDATE:
        nextState.forms[action.alias] = {
          values: action.values,
          valid: action.valid,
        }
    }
  })
}
